import { siteAssetPaths } from "@/lib/assets";

const MEMBERS = [
  { name: "管家 · L", role: "NUS · 4年", avatar: siteAssetPaths.butlerAvatar.l() },
  { name: "管家 · J", role: "NTU · 3年", avatar: siteAssetPaths.butlerAvatar.j() },
  { name: "管家 · S", role: "SMU · 2年", avatar: siteAssetPaths.butlerAvatar.s() },
] as const;

export function TeamPlaceholder() {
  return (
    <section className="px-5 pb-2 pt-6">
      <p className="kicker mb-3">团队</p>
      <h3 className="mb-4 text-[22px] font-bold leading-tight tracking-tight text-ink-900">
        在新加坡的真人管家,
        <br />
        不是国内的客服中心。
      </h3>
      <div className="grid grid-cols-3 gap-2.5">
        {MEMBERS.map((m) => (
          <div
            key={m.name}
            className="rounded-md border border-[var(--line)] bg-paper px-3 py-3.5 text-center"
          >
            <img
              src={m.avatar}
              alt={m.name}
              width={56}
              height={56}
              className="mx-auto mb-2 h-14 w-14 rounded-full object-cover"
            />
            <p className="text-[12.5px] font-medium text-ink-900">{m.name}</p>
            <p className="mt-0.5 font-mono text-[10.5px] tracking-wide text-ink-400">
              {m.role}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
